"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _useCopy3 = require("b2b-components/hooks/useCopy");
var _useIsomorphicLayoutEffect = require("b2b-components/hooks/useIsomorphicLayoutEffect");
var _useTooltip2 = require("b2b-components/hooks/useTooltip");
var _Content = require("../Content");
var _excluded = ["value", "getTooltipText", "children"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var WithContainer = function WithContainer(_ref) {
  var value = _ref.value,
    getTooltipText = _ref.getTooltipText,
    children = _ref.children,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useCopy = (0, _useCopy3.useCopy)({
      value: value
    }),
    _useCopy2 = (0, _slicedToArray2["default"])(_useCopy, 3),
    copyStatus = _useCopy2[0],
    onCopy = _useCopy2[1],
    resetCopyStatus = _useCopy2[2];
  var _useTooltip = (0, _useTooltip2.useTooltip)(),
    tooltipAnchorRef = _useTooltip.tooltipAnchorRef,
    tooltipRef = _useTooltip.tooltipRef,
    tooltipPosition = _useTooltip.tooltipPosition,
    isTooltipVisible = _useTooltip.isTooltipVisible,
    updateTooltipPosition = _useTooltip.updateTooltipPosition,
    onMouseEnter = _useTooltip.onMouseEnter,
    onMouseLeave = _useTooltip.onMouseLeave;
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    updateTooltipPosition();
  }, [copyStatus, updateTooltipPosition]);
  var handleMouseLeave = (0, _react.useCallback)(function (event) {
    resetCopyStatus();
    onMouseLeave(event);
  }, [onMouseLeave, resetCopyStatus]);
  var handleCopy = (0, _react.useCallback)(function (event) {
    event.stopPropagation();
    onCopy();
  }, [onCopy]);
  return /*#__PURE__*/_react["default"].createElement(_Content.Content, (0, _extends2["default"])({}, restProps, {
    isTooltipVisible: !!(isTooltipVisible && copyStatus),
    onCopy: handleCopy,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: onMouseEnter,
    tooltipAnchorRef: tooltipAnchorRef,
    tooltipPosition: tooltipPosition,
    tooltipRef: tooltipRef,
    tooltipText: getTooltipText(copyStatus)
  }), children);
};
exports.WithContainer = WithContainer;